module.exports = __webpack_public_path__ + "static/media/autotsne-original.fafb2dc8.gif";